/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 满意度调研设置保存
    SatisfactionSurveySetListShow ({ commit }, data) {
        return axios.post(http + '/Report/show', data).then(res => {
            return res.data
        })
    },
    // 满意度调研设置列表
    SaveSatisfactionSurveySet ({ commit }, data) {
        return axios.post(http + '/Report/add', data).then(res => {
            return res.data
        })
    },
    // 满意度调研设置删除
    DelSatisfactionSurveySet({ commit }, data) {
        return axios.post(http + '/Report/delete', data).then(res => {
            return res.data
        })
    },
    // 满意度调研列表
    SatisfactionSurveyListShow({ commit }, data) {
        return axios.post(http + '/Report/report_list', data).then(res => {
            return res.data
        })
    },
    // 满意度调研详情
    SatisfactionSurveyDetailShow({ commit }, data) {
        return axios.post(http + '/Report/report_detail', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const SatisfactionSurveyModule = {
    state,
    getters,
    actions,
    mutations
}
export default SatisfactionSurveyModule
